import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../types/enums";

export const MarketoHeaderBlock = () => {
  return (
    <Stack gap="8px">
      <Typography variant="h1" sx={{ color: "#232323" }}>
        Import data
      </Typography>
      <Typography variant="subtitle1" sx={{ color: "#464646" }}>
        To sync your Marketo data, enter your API credentials below. Not sure
        where to find them?{" "}
        <Link
          to={AppRoutes.MARKETO_GUIDE}
          style={{ color: "#0069C4" }}
          target="_blank"
        >
          <span>View the setup guide</span>
        </Link>{" "}
      </Typography>
      <Typography variant="subtitle1" sx={{ color: "#464646" }}>
        We handle your data securely: credentials are encrypted and never stored
        or used for any purpose other than connecting your account.{" "}
        <Link to={"#"} style={{ color: "#0069C4" }} target="_blank">
          <span>View our privacy policy.</span>
        </Link>
      </Typography>
    </Stack>
  );
};
